import styled, { keyframes, createGlobalStyle } from "styled-components";

/* ─────────────────────────────────── helpers ── */
export const isAdmin = () => localStorage.getItem("adminAccess") <= "2";
export const getMyName = () => localStorage.getItem("user_name");
export const toYMD = (d) => {
  const dayjs = require("dayjs");
  return dayjs(d).format("YYYY-MM-DD");
};
export const fmt = (d) => {
  const dayjs = require("dayjs");
  return d ? dayjs(d).format("DD MMM YYYY") : "—";
};
export const todayYMD = () => {
  const dayjs = require("dayjs");
  return toYMD(dayjs());
};
export const addDays = (n) => {
  const dayjs = require("dayjs");
  return toYMD(dayjs().add(n, "day"));
};
export const startOfWeek = () => {
  const dayjs = require("dayjs");
  return toYMD(dayjs().startOf("week").add(1, "day"));
};
export const startOfMonth = () => {
  const dayjs = require("dayjs");
  return toYMD(dayjs().startOf("month"));
};
export const n = (val) => {
  if (val === "Not Required" || val === null || val === undefined) return 0;
  return Number(val) || 0;
};
export const pct = (num, den) =>
  den === 0 ? "—" : `${Math.round((num / den) * 100)}%`;

/* ─────────────────────────────────── palettes ── */
export const CLIENT_PALETTE = [
  { bg: "#FED7AA", fg: "#9A3412" }, { bg: "#BBF7D0", fg: "#14532D" },
  { bg: "#BFDBFE", fg: "#1E3A8A" }, { bg: "#DDD6FE", fg: "#4C1D95" },
  { bg: "#FECDD3", fg: "#9F1239" }, { bg: "#FEF08A", fg: "#713F12" },
  { bg: "#BAE6FD", fg: "#0C4A6E" }, { bg: "#F5D0FE", fg: "#701A75" },
  { bg: "#99F6E4", fg: "#134E4A" }, { bg: "#FCA5A5", fg: "#7F1D1D" },
  { bg: "#C7D2FE", fg: "#312E81" }, { bg: "#D9F99D", fg: "#365314" },
  { bg: "#FDBA74", fg: "#7C2D12" }, { bg: "#A5F3FC", fg: "#164E63" },
  { bg: "#E9D5FF", fg: "#581C87" }, { bg: "#FDE68A", fg: "#92400E" },
];
export const RECRUITER_PALETTE = [
  { bg: "#EDE9FE", fg: "#5B21B6" }, { bg: "#FCE7F3", fg: "#9D174D" },
  { bg: "#D1FAE5", fg: "#065F46" }, { bg: "#FEF3C7", fg: "#92400E" },
  { bg: "#DBEAFE", fg: "#1E40AF" }, { bg: "#FFE4E6", fg: "#9F1239" },
];
export const hashStr = (str) => {
  let h = 5381;
  for (let i = 0; i < (str || "").length; i++) {
    h = ((h << 5) + h) ^ str.charCodeAt(i);
    h = h & h;
  }
  return Math.abs(h);
};
export const clientColor = (name) =>
  CLIENT_PALETTE[hashStr(name || "") % CLIENT_PALETTE.length];

/* ─────────────────────────────────── animations ── */
export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(18px); }
  to   { opacity: 1; transform: translateY(0); }
`;
export const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;
export const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.55; }
`;
export const expandDown = keyframes`
  from { opacity: 0; max-height: 0; transform: scaleY(0.95); }
  to   { opacity: 1; max-height: 2000px; transform: scaleY(1); }
`;

/* ─────────────────────────────────── styled ── */
export const GlobalFonts = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600;700&display=swap');
`;

export const MainDiv = styled.div`
  display: flex; flex-direction: row; flex-grow: 1;
  background: #F0F2FA; overflow: hidden;
`;
export const ContentWrapDiv = styled.div`
  display: flex; flex-direction: column;
  height: 100vh; padding: 28px 32px 24px 32px;
  flex: 1; min-width: 0; overflow: hidden;
  font-family: 'DM Sans', 'Segoe UI', sans-serif;
  box-sizing: border-box; border-top: 5px solid #6366F1;
`;
export const TopContainer = styled.div`
  display: flex; justify-content: space-between;
  align-items: flex-start; margin-bottom: 20px;
  flex-shrink: 0; gap: 12px; flex-wrap: wrap;
  .left { display: flex; flex-direction: column; gap: 3px; }
  .page-title {
    font-family: 'Syne', sans-serif;
    font-weight: 800; font-size: 30px; line-height: 1.1;
    color: #0F172A; letter-spacing: -0.6px;
  }
  .date-label { font-size: 13px; color: #64748B; font-weight: 700; }
  .right { display: flex; align-items: center; gap: 8px; padding-top: 4px; }
`;
export const RangeTabsWrapper = styled.div`
  display: flex; background: #E2E5F5;
  border-radius: 12px; padding: 4px; gap: 2px;
`;
export const RangeTab = styled.button`
  padding: 6px 13px; border-radius: 9px; border: none;
  background: ${({ active }) => active ? "linear-gradient(135deg,#4F46E5 0%,#7C3AED 100%)" : "transparent"};
  color: ${({ active }) => active ? "#fff" : "#64748B"};
  font-weight: ${({ active }) => active ? 700 : 500};
  font-size: 13px; cursor: pointer; transition: all 0.18s ease;
  white-space: nowrap;
  box-shadow: ${({ active }) => active ? "0 2px 10px rgba(79,70,229,0.35)" : "none"};
  &:hover {
    background: ${({ active }) => active ? "linear-gradient(135deg,#4338CA 0%,#6D28D9 100%)" : "#D4D8EE"};
    color: ${({ active }) => active ? "#fff" : "#374151"};
  }
`;
export const FilterRow = styled.div`
  display: flex; gap: 12px; flex-wrap: wrap;
  align-items: center; margin-bottom: 20px; flex-shrink: 0;
  .date-sep { font-size: 14px; color: #94A3B8; font-weight: 600; }
`;
export const StyledSelectWrap = styled.div`
  .ant-select-selector {
    height: 42px !important; border-radius: 12px !important;
    border: 1px solid #D7DDED !important;
    display: flex; align-items: center;
    padding: 0 12px !important; box-shadow: none !important; overflow: visible !important;
  }
  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    height: 40px !important; line-height: 40px !important;
    font-size: 14px; font-weight: 500; overflow: visible !important;
  }
   .ant-select-selection-search {
    display: flex !important;
    align-items: center !important;
    margin: 0 !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100% !important;
  }
  .ant-select-selection-search-input {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .ant-select-arrow { color: #94A3B8; }
  .ant-select-focused .ant-select-selector {
    border-color: #818CF8 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.08) !important;
  }
  .ant-select-selector:hover { border-color: #A5B4FC !important; }
`;
export const StyledDatePickerWrap = styled.div`
  .ant-picker {
    height: 42px !important; border-radius: 12px !important;
    display: flex; align-items: center; padding: 0 12px;
    border: 1px solid #D7DDED; box-shadow: none;
  }
  .ant-picker:hover { border-color: #A5B4FC; }
  .ant-picker-focused {
    border-color: #818CF8 !important;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.08) !important;
  }
  .ant-picker-input { height: 100%; display: flex; align-items: center; }
  .ant-picker-input > input {
    height: 100%; font-size: 14px; font-weight: 600; color: #334155;
  }
  .ant-picker-suffix { padding-left: 8px; color: #94A3B8; }
`;
export const FilterRecruiterChip = styled.span`
  display: inline-flex; align-items: center; height: 24px;
  padding: 0 10px; border-radius: 7px; font-size: 12px;
  font-weight: 700; white-space: nowrap;
  background: ${({ bg }) => bg}; color: ${({ fg }) => fg};
`;
export const FilterClientChip = styled.span`
  display: inline-flex; align-items: center; height: 22px;
  padding: 0 9px; border-radius: 6px; font-size: 11px;
  font-weight: 700; white-space: nowrap;
  background: ${({ bg }) => bg}; color: ${({ fg }) => fg};
`;
export const FilterRoleChip = styled.span`
  display: inline-flex; align-items: center; height: 24px;
  padding: 0 10px; border-radius: 7px; font-size: 12px;
  font-weight: 700; white-space: nowrap;
  background: ${({ bg }) => bg}; color: ${({ fg }) => fg};
  max-width: 160px; overflow: hidden; text-overflow: ellipsis;
`;

/* ── Dashboard scroll area ── */
export const DashScrollArea = styled.div`
  flex: 1; overflow-y: auto; overflow-x: hidden;
  padding-bottom: 24px;
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 10px; }
`;

/* ── Top KPI strip ── */
export const KPIStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px; margin-bottom: 28px;
`;
export const KPICard = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 18px 20px 16px;
  position: relative; overflow: hidden;
  display: flex; flex-direction: column;   /* ← add these two */
  box-shadow: 0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.05);
  border: 1px solid ${({ accent }) => accent}22;
  animation: ${fadeUp} 0.4s ease both;
  animation-delay: ${({ idx }) => (idx || 0) * 0.05}s;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  cursor: default;
  &::before {
    content: ""; position: absolute; top: 0; left: 0; right: 0;
    height: 3px; background: ${({ accent }) => accent};
    border-radius: 16px 16px 0 0;
  }
  &:hover { transform: translateY(-3px); box-shadow: 0 8px 28px ${({ accent }) => accent}22; }
`;


export const KPICountLabel = styled.div`
  font-size: 11px; color: #94A3B8; font-weight: 600;
  margin-top: auto; padding-top: 8px;
`;
export const KPIValue = styled.div`
  font-family: 'Syne', sans-serif;
  font-size: 36px; font-weight: 800; line-height: 1;
  color: ${({ accent }) => accent}; letter-spacing: -1.5px;
  margin-bottom: 6px; font-variant-numeric: tabular-nums;
`;
export const KPILabel = styled.div`
  font-size: 10px; color: #94A3B8; font-weight: 700;
  text-transform: uppercase; letter-spacing: 1px;
`;
export const KPISubLabel = styled.div`
  font-size: 11px; color: #CBD5E1; font-weight: 500; margin-top: 2px;
`;

/* ── Section title ── */
export const SectionTitle = styled.div`
  font-family: 'Syne', sans-serif;
  font-size: 13px; font-weight: 700; color: #64748B;
  text-transform: uppercase; letter-spacing: 1.5px;
  margin-bottom: 14px; display: flex; align-items: center; gap: 10px;
  &::after { content: ""; flex: 1; height: 1px; background: #E2E8F0; }
`;

/* ── Funnel stages grid ── */
export const FunnelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px; margin-bottom: 28px;
`;

/* ── Individual stage card ── */
export const StageCard = styled.div`
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  display: flex;                /* ← add */
  flex-direction: column;       /* ← add */
  box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 4px 20px rgba(0,0,0,0.06);
  border: 1px solid ${({ accent }) => accent}20;
  animation: ${fadeUp} 0.4s ease both;
  animation-delay: ${({ idx }) => (idx || 0) * 0.06}s;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  &:hover { transform: translateY(-4px); box-shadow: 0 12px 36px ${({ accent }) => accent}1A; }
`;
export const StageHeader = styled.div`
  background: ${({ accent }) => accent};
  padding: 14px 16px 12px;
  display: flex; align-items: center; justify-content: space-between;
`;
export const StageIcon = styled.div`
  font-size: 22px; line-height: 1;
`;
export const StageTitle = styled.div`
  font-family: 'Syne', sans-serif;
  font-size: 13px; font-weight: 700;
  color: ${({ light }) => light ? "#fff" : "#1E293B"};
  letter-spacing: 0.2px; flex: 1; margin: 0 10px;
`;
export const StageBadge = styled.div`
  background: ${({ light }) => light ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.08)"};
  color: ${({ light }) => light ? "#fff" : "#334155"};
  font-size: 10px; font-weight: 700; padding: 3px 9px;
  border-radius: 20px; text-transform: uppercase; letter-spacing: 0.8px;
`;
export const StageBody = styled.div`
  padding: 16px 18px 14px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 180px;
`;
export const StageMainNum = styled.div`
  font-family: 'Syne', sans-serif;
  font-size: 42px; font-weight: 800; line-height: 1;
  color: ${({ accent }) => accent}; letter-spacing: -2px;
  margin-bottom: 2px; font-variant-numeric: tabular-nums;
`;
export const StageMainLabel = styled.div`
  font-size: 11px; color: #94A3B8; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 14px;
`;
export const StageDivider = styled.div`
  height: 1px; background: #F1F5F9; margin: 12px 0;
`;
export const StageDeductions = styled.div`
  display: flex; flex-direction: column; gap: 6px;
`;
export const DeductRow = styled.div`
  display: flex; align-items: center; justify-content: space-between;
`;
export const DeductLabel = styled.span`
  font-size: 11.5px; color: #64748B; font-weight: 500;
  display: flex; align-items: center; gap: 5px;
  &::before {
    content: "−"; font-weight: 700; font-size: 13px;
    color: ${({ color }) => color || "#EF4444"};
  }
`;
export const DeductVal = styled.span`
  font-size: 12.5px; font-weight: 700;
  color: ${({ color }) => color || "#EF4444"};
  font-variant-numeric: tabular-nums;
  background: ${({ color }) => color || "#EF4444"}14;
  padding: 2px 9px; border-radius: 20px;
`;

export const StageBottom = styled.div`
  margin-top: auto;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StageConversion = styled.div`
  padding: 8px 12px;
  background: ${({ accent }) => accent}0D;
  border-radius: 10px; display: flex; align-items: center;
  justify-content: space-between;
`;

export const ConvLabel = styled.span`
  font-size: 11px; color: #94A3B8; font-weight: 600;
`;
export const ConvValue = styled.span`
  font-family: 'Syne', sans-serif;
  font-size: 16px; font-weight: 800;
  color: ${({ accent }) => accent};
`;

/* ── Expanded detail panel ── */
export const DetailPanel = styled.div`
  margin-top: -8px; margin-bottom: 14px;
  background: #F8F9FF;
  border: 1px solid #E0E7FF;
  border-radius: 0 0 16px 16px;
  padding: 18px 20px;
  animation: ${expandDown} 0.25s ease both;
  transform-origin: top;
`;
export const DetailTitle = styled.div`
  font-size: 12px; font-weight: 700; color: #6366F1;
  text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px;
`;
export const AccountList = styled.div`
  display: flex; flex-direction: column; gap: 8px;
`;
export const AccountItem = styled.div`
  background: #fff; border-radius: 10px;
  padding: 10px 14px; display: flex; align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  border-left: 3px solid ${({ accent }) => accent};
`;
export const AccountName = styled.span`
  font-size: 12px; font-weight: 600; color: #334155;
`;
export const AccountVal = styled.span`
  font-family: 'Syne', sans-serif;
  font-size: 18px; font-weight: 800;
  color: ${({ accent }) => accent};
`;

/* ── Export button ── */
export const ExportBtn = styled.button`
  display: flex; align-items: center; gap: 7px;
  background: linear-gradient(135deg,#10B981 0%,#059669 100%);
  color: #fff; border: none; border-radius: 11px;
  padding: 9px 18px; font-size: 13px; font-weight: 700;
  cursor: pointer; transition: all 0.18s ease;
  box-shadow: 0 2px 10px rgba(16,185,129,0.35);
  white-space: nowrap;
  &:hover {
    background: linear-gradient(135deg,#059669 0%,#047857 100%);
    transform: translateY(-1px); box-shadow: 0 4px 16px rgba(16,185,129,0.4);
  }
  &:active { transform: translateY(0); }
`;

export const SpinWrap = styled.div`
  display: flex; align-items: center; justify-content: center; height: 300px;
`;
export const EmptyWrap = styled.div`
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; padding: 80px 0; color: #94A3B8; font-size: 14px; gap: 12px;
  .icon { font-size: 48px; }
`;

/* ── Connector arrow between funnel stages ── */
export const ConnectorArrow = styled.div`
  display: flex; align-items: center; justify-content: center;
  color: #CBD5E1; font-size: 20px; font-weight: 300;
  padding: 2px 0; grid-column: 1 / -1;
  &::before, &::after {
    content: ""; flex: 1; height: 1px;
    background: linear-gradient(90deg, transparent, #E2E8F0, transparent);
  }
  span { padding: 0 16px; }
`;